import React from 'react';

import { Tag } from 'antd';

import fetch from './../fetch';
import utils from './../../utils';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    // {type: 'selection'},
    { key: '$index', label: '序号', width: 80 },
    { key: 'type', label: '汇总类型', render: (val) => {
        if (val == 'EVAL_STUDENT') {
            return 'EVAL_STUDENT(学生评教)'
        } else if (val == 'SUPERVISION'){
            return 'SUPERVISION(督导评教)'
        }else if (val == 'PEER_TEACHER'){
            return 'PEER_TEACHER(同行评教)'
        }
    }, width: 120 },
    {
        key: 'status', label: '汇总状态', render: (val) => {
            if (val == 1) {
                return <Tag color="blue">开始中</Tag>
            } else if (val == 2) {
                return <Tag color="green">已完成</Tag>
            } return <Tag color="red">汇总失败</Tag>
        }, width: 120
    },
    { key: 'totalCount', label: '总记录数', width: 120 },
    { key: 'successCount', label: '成功的记录数', width: 120 },
    { key: 'failCount', label: '失败的记录数', width: 120 },
    { key: 'beginTime', label: '开始时间', width: 120 },
    { key: 'endTime', label: '结束时间', width: 120 },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'syncMessage', label: '汇总消息', width: 150 },
]);

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/eval/data/summary/query?' + params.join('&'), keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const saveSetting = (data) => {
    return fetch.post('eval/data/summary/saveSetting', data)
}

const getSetting = (type) => {
    return fetch.get(`eval/data/summary/getSetting/${type}`)
}

const preview = (data) => {
    return fetch.post(`eval/data/summary/preview`, data)
}

const sync = (type) => {
    return fetch.post(`eval/data/summary/sync/${type}`)
}

const remove = (ids) => {
    return fetch.post(`eval/data/summary/remove`, ids)
}

export default {
    columns,
    querySearch,
    onSelect,
    setRefresh,
    getSelection,
    saveSetting,
    getSetting,
    preview,
    sync,
    remove,
}